"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractGeneralInfo = class UcContractGeneralInfo extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    ux;
    b_6379803495938895_to;
    async $$load_b_6379803495938895_to() {
        return {
            name: "app.company",
            params: {
                id: this.contract.company.id,
            },
        };
    }
    b_8906220998092919_to;
    async $$load_b_8906220998092919_to() {
        return {
            name: "app.company",
            params: {
                id: this.contract.counterparty.id,
            },
        };
    }
    dataMembers = ['ux', 'b_6379803495938895_to', 'b_8906220998092919_to'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
                b_6379803495938895_to: null,
                b_8906220998092919_to: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_emit_8710_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8320016629450276_close_8709_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_8320016629450276_showModal_8708_getActionArgs($event) {
        return {
            name: "ContractEditor",
            props: {
                target: "general",
                contract: _.cloneDeep(this.contract),
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7349226261686150_emit_8712_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7349226261686150_reload(event, scope) {
        return await this.actions.evh_7349226261686150_reload.executeFromDOM(this, event, scope);
    }
    async act_5937240531526321_emit_8716_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5937240531526321_close_8715_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_5937240531526321_showModal_8714_getActionArgs($event) {
        return {
            name: "ContractEditor",
            props: {
                target: "company",
                contract: _.cloneDeep(this.contract),
            },
        };
    }
    async evh_5937240531526321_clickPreventStop(event, scope) {
        return await this.actions.evh_5937240531526321_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7527485200259320_emit_8720_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7527485200259320_close_8719_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_7527485200259320_showModal_8718_getActionArgs($event) {
        return {
            name: "ContractEditor",
            props: {
                target: "counterparty",
                contract: _.cloneDeep(this.contract),
            },
        };
    }
    async evh_7527485200259320_clickPreventStop(event, scope) {
        return await this.actions.evh_7527485200259320_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7127218473441393_emit_8724_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_7127218473441393_close_8723_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_7127218473441393_showModal_8722_getActionArgs($event) {
        return {
            name: "ContractEditor",
            props: {
                target: "rental",
                contract: this.contract.rental
                    ? _.cloneDeep(this.contract)
                    : _.extend(_.cloneDeep(this.contract), {
                        rental: {
                            id: null,
                            name: null,
                            number: null,
                            description: null,
                            house_number: null,
                            inactive: false,
                            location_code: null,
                            lot_number: null,
                        }
                    }),
            },
        };
    }
    async evh_7127218473441393_clickPreventStop(event, scope) {
        return await this.actions.evh_7127218473441393_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_4198689235226718_reload(event, scope) {
        return await this.actions.evh_4198689235226718_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8706 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8705 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8706,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8705],
        });
        const act_8320016629450276_emit_8710 = new core_1.actions.EmitAction({
            actionArgs: this.act_8320016629450276_emit_8710_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_close_8709 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_emit_8710,
            event: "close",
            when: this.evh_8320016629450276_close_8709_getWhen,
            displayName: "emit",
        });
        const act_8320016629450276_showModal_8708 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_8708_getActionArgs,
            events: [evh_8320016629450276_close_8709],
        });
        const evh_8320016629450276_clickPreventStop_8707 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_8708,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_8707],
        });
        const act_7349226261686150_emit_8712 = new core_1.actions.EmitAction({
            actionArgs: this.act_7349226261686150_emit_8712_getActionArgs,
            events: [],
        });
        const evh_7349226261686150_reload_8711 = new core_1.actions.EventHandlerImpl({
            action: act_7349226261686150_emit_8712,
            event: "reload",
            displayName: "emit",
        });
        const evh_7349226261686150_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7349226261686150_reload_8711],
        });
        const act_5937240531526321_emit_8716 = new core_1.actions.EmitAction({
            actionArgs: this.act_5937240531526321_emit_8716_getActionArgs,
            events: [],
        });
        const evh_5937240531526321_close_8715 = new core_1.actions.EventHandlerImpl({
            action: act_5937240531526321_emit_8716,
            event: "close",
            when: this.evh_5937240531526321_close_8715_getWhen,
            displayName: "emit",
        });
        const act_5937240531526321_showModal_8714 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5937240531526321_showModal_8714_getActionArgs,
            events: [evh_5937240531526321_close_8715],
        });
        const evh_5937240531526321_clickPreventStop_8713 = new core_1.actions.EventHandlerImpl({
            action: act_5937240531526321_showModal_8714,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_5937240531526321_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5937240531526321_clickPreventStop_8713],
        });
        const act_7527485200259320_emit_8720 = new core_1.actions.EmitAction({
            actionArgs: this.act_7527485200259320_emit_8720_getActionArgs,
            events: [],
        });
        const evh_7527485200259320_close_8719 = new core_1.actions.EventHandlerImpl({
            action: act_7527485200259320_emit_8720,
            event: "close",
            when: this.evh_7527485200259320_close_8719_getWhen,
            displayName: "emit",
        });
        const act_7527485200259320_showModal_8718 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7527485200259320_showModal_8718_getActionArgs,
            events: [evh_7527485200259320_close_8719],
        });
        const evh_7527485200259320_clickPreventStop_8717 = new core_1.actions.EventHandlerImpl({
            action: act_7527485200259320_showModal_8718,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_7527485200259320_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7527485200259320_clickPreventStop_8717],
        });
        const act_7127218473441393_emit_8724 = new core_1.actions.EmitAction({
            actionArgs: this.act_7127218473441393_emit_8724_getActionArgs,
            events: [],
        });
        const evh_7127218473441393_close_8723 = new core_1.actions.EventHandlerImpl({
            action: act_7127218473441393_emit_8724,
            event: "close",
            when: this.evh_7127218473441393_close_8723_getWhen,
            displayName: "emit",
        });
        const act_7127218473441393_showModal_8722 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7127218473441393_showModal_8722_getActionArgs,
            events: [evh_7127218473441393_close_8723],
        });
        const evh_7127218473441393_clickPreventStop_8721 = new core_1.actions.EventHandlerImpl({
            action: act_7127218473441393_showModal_8722,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_7127218473441393_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7127218473441393_clickPreventStop_8721],
        });
        const act_4198689235226718_reloadComponentData_8726 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_4198689235226718_reload_8725 = new core_1.actions.EventHandlerImpl({
            action: act_4198689235226718_reloadComponentData_8726,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_4198689235226718_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4198689235226718_reload_8725],
        });
        return {
            act_7315092382398562_reloadComponentData_8706,
            evh_7315092382398562_reload_8705,
            evh_7315092382398562_reload,
            act_8320016629450276_emit_8710,
            evh_8320016629450276_close_8709,
            act_8320016629450276_showModal_8708,
            evh_8320016629450276_clickPreventStop_8707,
            evh_8320016629450276_clickPreventStop,
            act_7349226261686150_emit_8712,
            evh_7349226261686150_reload_8711,
            evh_7349226261686150_reload,
            act_5937240531526321_emit_8716,
            evh_5937240531526321_close_8715,
            act_5937240531526321_showModal_8714,
            evh_5937240531526321_clickPreventStop_8713,
            evh_5937240531526321_clickPreventStop,
            act_7527485200259320_emit_8720,
            evh_7527485200259320_close_8719,
            act_7527485200259320_showModal_8718,
            evh_7527485200259320_clickPreventStop_8717,
            evh_7527485200259320_clickPreventStop,
            act_7127218473441393_emit_8724,
            evh_7127218473441393_close_8723,
            act_7127218473441393_showModal_8722,
            evh_7127218473441393_clickPreventStop_8721,
            evh_7127218473441393_clickPreventStop,
            act_4198689235226718_reloadComponentData_8726,
            evh_4198689235226718_reload_8725,
            evh_4198689235226718_reload,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractGeneralInfo.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractGeneralInfo.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcContractGeneralInfo.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractGeneralInfo.prototype, "onReadonly", null);
UcContractGeneralInfo = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractGeneralInfo);
exports.default = UcContractGeneralInfo;
vue_property_decorator_1.Vue.component("UcContractGeneralInfo", UcContractGeneralInfo);
